import React from "react";
import { Helmet } from "react-helmet-async";
import HighRoofVanHero from "../components/highroof-van/HighRoofVanHero";
import ServiceHighRoof from "../components/highroof-van/ServiceHighRoof";
import ChillerFreezeSectionHighRoof from "../components/highroof-van/ChillerFreezeSectionHighRoof";
import TrucksVansComparison from "../components/freezer-van/TrucksVansComparison";

// import ChillerFleetServiceSliderContentSimple from "../components/home/ChillerFleetServiceSliderContentSimple";

import HighRoofSection from "../components/highroof-van/HighRoofSection";

const HighRoof = () => {
  return (
    <>
      <Helmet>
        <title>High Roof Van Rental Dubai | Refrigerated Transport UAE | Chiller Fleet</title>
        <meta name="description" content="Rent high roof refrigerated vans in Dubai with Chiller Fleet. 24/7 cold chain transport solutions for food, pharmaceuticals, and other temperature-sensitive goods across UAE." />
        <meta property="og:title" content="High Roof Van Rental Dubai | Refrigerated Transport UAE | Chiller Fleet" />
        <meta property="og:description" content="Rent high roof refrigerated vans in Dubai with Chiller Fleet. 24/7 cold chain transport solutions for food, pharmaceuticals, and other temperature-sensitive goods across UAE." />
        <meta property="og:url" content="https://chillerfleet.com/services/high-roof-vans" />
        <meta name="twitter:title" content="High Roof Van Rental Dubai | Refrigerated Transport UAE | Chiller Fleet" />
        <meta name="twitter:description" content="Rent high roof refrigerated vans in Dubai with Chiller Fleet. 24/7 cold chain transport solutions for food, pharmaceuticals, and other temperature-sensitive goods across UAE." />
      </Helmet>

      <HighRoofVanHero />
      <HighRoofSection />

      <ServiceHighRoof />

      <ChillerFreezeSectionHighRoof />

      <TrucksVansComparison />
    </>
  );
};

export default HighRoof;
